module.exports = __webpack_public_path__ + "img/photo.4d5a8e91.webp";